import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import {
  collection,
  getDocs,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { db } from "../config/FirebaseConfig";
import { getDocDataById, queryCollection } from "../models/DataFunctions";
import debounce from "lodash.debounce"; // Install lodash for debouncing
import { useLocation } from "react-router-dom";
const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // Define initial state

  const initialState = {
    user: null,
    theme: "light",
    dev: false,
    dev_url: "http://127.0.0.1:8000/",
    prod_url: "https://api.logement.hexagone.expert/",
    dev_ws: "http://127.0.0.1:8081/",
    prod_ws: process.env.REACT_APP_WS_URL,
    folders_config: null,
    login_security: null,
    planning_config: null,
    carnets: [],

    // Add other state variables as needed
  };

  const [appState, setAppState] = useState(() => {
    const savedState = localStorage.getItem("appState");
    if (savedState) {
      return JSON.parse(savedState);
    } else {
      console.warn("No saved state found in localStorage");

      return initialState;
    }
  });
  // Save appState to localStorage whenever it changes
  useEffect(() => {
    const { saved_data, ...stateToSave } = appState; // Exclude saved_data
    localStorage.setItem("appState", JSON.stringify(stateToSave));
  }, [appState]);

  // Load the initial state from localStorage or set default values

  const resetAppStateLogin = async () => {
    setAppState((prevState) => ({
      ...prevState,
      folders: null,
      events: null,
      folders_config: {},
    }));
  };

  async function fetchCarnets(orgData) {
    console.log("fetchCarnets", orgData);
    let filters = [
      {
        field: "master_id",
        operator: "==",
        value: orgData.id,
      },
    ];
    let carnets = await queryCollection("carnet", filters);
    let partnersfilters = [
      {
        field: "partners_id",
        operator: "array-contains",
        value: orgData.id,
      },
    ];
    let partnerscarnets =
      (await queryCollection("carnet", partnersfilters)) || [];
    let allcarnets = carnets.concat(partnerscarnets);
    setAppState((prevState) => ({
      ...prevState,
      carnets: allcarnets,
    }));
    return allcarnets;
  }

  // Reset function to restore appState to initial values
  const resetAppState = () => {
    setAppState(initialState);
  };

  return (
    <AppContext.Provider
      value={{
        appState,
        setAppState,

        resetAppState,

        resetAppStateLogin,
        fetchCarnets,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppContext);
};
